import {
  ProposalProductListResponseDTO,
  TIPO_PESSOA
} from "@repo/core/services/entities/Proposals";
import { ProposalProduct } from "@repo/core/types/proposals";

export const INDIVIDUAL_PL_SEGMENT = "PL";

export const NO_AVAILABLE_PRODUCTS_TOAST = {
  title: "Nenhum produto disponível",
  description: "Não há produtos disponíveis para iniciar a proposta."
} as const;

export type ProductsScreenOutcome =
  | "loading"
  | "empty"
  | "autoSelect"
  | "select";

export const getProductsScreenOutcome = (
  isFetchingProducts: boolean,
  productsCount: number
): ProductsScreenOutcome => {
  if (isFetchingProducts) return "loading";
  if (productsCount === 0) return "empty";
  if (productsCount === 1) return "autoSelect";
  return "select";
};

export const isIndividualPlProduct = (
  product: Pick<ProposalProductListResponseDTO, "segmento" | "tipoPessoa">
): boolean =>
  product.segmento === INDIVIDUAL_PL_SEGMENT &&
  product.tipoPessoa === TIPO_PESSOA.FISICA;

export const filterIndividualPlProducts = <
  T extends Pick<ProposalProductListResponseDTO, "segmento" | "tipoPessoa">
>(
  products: T[]
): T[] => products.filter(isIndividualPlProduct);

export const mapSelectableProducts = (
  products: ProposalProductListResponseDTO[] | undefined
): ProposalProduct[] => {
  if (!products) return [];

  return filterIndividualPlProducts(products).map((product) => ({
    id: product.produto,
    name: product.abreviatura,
    number: product.produto
  }));
};
